export default __webpack_public_path__ + "static/media/GR8 6A-2B-6EC.d764d38c.jpg";